import { RestClient } from "clients/rest";
import { catchRestError, FileClient } from "../RestClient";
import { PageableResponse } from "../PageableResponse";
import { UseFormReturn } from "react-hook-form";

export type B090011FindRequest = {
  sokoCd: string;
} & Partial<{
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  shohinKana: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  locationCdFrom: string;
  locationCdTo: string;
  shohinshubetsuKbn: string;
  gokeisuHyoji: string;
  nyukayoteisuHyoji: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B090011FindResponse = {
  shohinCd: string;
  shohinNmr: string;
  sokoCd: string;
  sokoNmr: string;
  zaikosu: string;
  nyukayoteisu: string;
  shukayoteisu: string;
  locationCdView: string;
  janCd: string;
  saishushireYmd: string;
  sokoshubetsuKbn: string;
  zaikosuGokei: string;
  nyukayoteisuGokei: string;
  shukayoteisuGokei: string;
};

//検索処理
export const B090011Find = (props: B090011FindRequest) => {
  return RestClient.get<PageableResponse<B090011FindResponse>>("b090011/find", {
    params: props,
  });
};

export type B090011ExcelRequest = {
  sokoCd: string;
} & Partial<{
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  shohinKana: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  locationCdFrom: string;
  locationCdTo: string;
  shohinshubetsuKbn: string;
  gokeisuHyoji: string;
  nyukayoteisuHyoji: string;
  sort: string[];
}>;

//Excel出力処理
export const B090011GetExcel = (props: B090011ExcelRequest) => {
  return FileClient.get("b090011/get/excel", {
    params: props,
  });
};

export const B090011GetPhysicalsoko = () => {
  return RestClient.get("b090011/get/physicalsoko", {});
};

//初期表示処理
export const B090011Soko = (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  B090011GetPhysicalsoko()
    .then((response) => {
      methods.setValue("sokoCd", response.data.sokoCd ?? "");
      methods.setValue("sokoNmr", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoCd", "");
      methods.setValue("sokoNmr", "");
    });
};
